// TODO 补全国际化
export default {
  EDT_PV: {
    zh_cn: '光伏逆变器',
    zhhant: '光伏逆變器',
    en: 'PV Inverter',
    he: 'מהפך PV',
    de: 'PV-Wechselrichter',
    es: 'Inversor fotovoltaico',
    ru: 'Солнечный инвертор',
    vi: 'Bộ biến tần PV',
  },
  EDT_ES: {
    zh_cn: '储能逆变器(电池储能)',
    zhhant: '儲能逆變器(電池儲能)',
    en: 'Energy Storage Inverter (Battery Storage)',
    he: 'מהפך אגירת אנרגיה (אגירת סוללה)',
    de: 'Speicherwechselrichter (Batteriespeicher)',
    es: 'Inversor de almacenamiento de energía (batería)',
    ru: 'Инвертор накопления энергии (аккумулятор)',
    vi: 'Bộ biến tần lưu trữ năng lượng (lưu trữ pin)',
  },
  EDT_HYBRID: {
    zh_cn: '混合逆变器(光储一体化)',
    zhhant: '混合逆變器(光儲一體化)',
    en: 'Hybrid Inverter (PV & Storage)',
    he: 'מהפך היברידי (PV ואגירה)',
    de: 'Hybrid-Wechselrichter (PV & Speicher)',
    es: 'Inversor híbrido (FV y almacenamiento)',
    ru: 'Гибридный инвертор (СЭС и накопитель)',
    vi: 'Bộ biến tần lai (PV & lưu trữ)',
  },
  EDT_MICRO: {
    zh_cn: '微电网逆变器',
    zhhant: '微電網逆變器',
    en: 'Microgrid Inverter',
    he: 'מהפך מיקרורשת',
    de: 'Mikronetz-Wechselrichter',
    es: 'Inversor de microrred',
    ru: 'Инвертор микросети',
    vi: 'Bộ biến tần vi lưới',
  },
  EDT_GRID: {
    zh_cn: '并网逆变器',
    zhhant: '併網逆變器',
    en: 'Grid-tied Inverter',
    he: 'מהפך מחובר לרשת',
    de: 'Netzgekoppelter Wechselrichter',
    es: 'Inversor conectado a red',
    ru: 'Сетевой инвертор',
    vi: 'Bộ biến tần nối lưới',
  },
  EDT_OFFGRID: {
    zh_cn: '离网逆变器',
    zhhant: '離網逆變器',
    en: 'Off-grid Inverter',
    he: 'מהפך לא מחובר לרשת',
    de: 'Inselwechselrichter',
    es: 'Inversor fuera de red',
    ru: 'Автономный инвертор',
    vi: 'Bộ biến tần độc lập',
  },
  EGT_Unknown: {
    zh_cn: '未知并网方式',
    zhhant: '未知併網方式',
    en: 'Unknown Grid Type',
    he: 'סוג רשת לא ידוע',
    de: 'Unbekannter Netztyp',
    es: 'Tipo de red desconocido',
    ru: 'Неизвестный тип сети',
    vi: 'Kiểu nối lưới không xác định',
  },
  EGT_FeedbackAll: {
    zh_cn: '全额馈网',
    zhhant: '全額饋網',
    en: 'Full Feed-in',
    he: 'הזנה מלאה לרשת',
    de: 'Volle Netzeinspeisung',
    es: 'Alimentación total a la red',
    ru: 'Полная подача в сеть',
    vi: 'Cấp điện toàn phần',
  },
  EGT_SelfSufficiency: {
    zh_cn: '自发自用(部分馈网)',
    zhhant: '自發自用(部分饋網)',
    en: 'Self-consumption (Partial Feed-in)',
    he: 'צריכה עצמית (הזנה חלקית לרשת)',
    de: 'Eigenverbrauch (teilweise Netzeinspeisung)',
    es: 'Autoconsumo (alimentación parcial)',
    ru: 'Самопотребление (частичная подача в сеть)',
    vi: 'Tự tiêu thụ (cấp điện một phần)',
  },
  EGT_NoFeedback: {
    zh_cn: '无馈网',
    zhhant: '無饋網',
    en: 'No Feed-in',
    he: 'ללא הזנה לרשת',
    de: 'Keine Netzeinspeisung',
    es: 'Sin alimentación a la red',
    ru: 'Без подачи в сеть',
    vi: 'Không cấp điện lưới',
  },
  EGT_OffGrid: {
    zh_cn: '离网',
    zhhant: '離網',
    en: 'Off-grid',
    he: 'לא מחובר לרשת',
    de: 'Inselbetrieb',
    es: 'Fuera de red',
    ru: 'Автономный',
    vi: 'Độc lập lưới',
  },
}
